import {MCP_API_URL} from "../../../settings/local_settings";
import {LocalStorage} from "../../../utils/LocalStorage";

const BASE_URL = MCP_API_URL + '/api/v1';

function getHeaders() {
    const token = LocalStorage.fetchUserToken();
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}

async function buildError(response) {
    let errorData = {};
    try { errorData = await response.json(); } catch (e) {}
    const error = new Error(errorData.message || errorData.error || `HTTP ${response.status}`);
    error.errorType = errorData.error || '';
    return error;
}

export async function listClients() {
    const response = await fetch(`${BASE_URL}/clients`, {
        method: 'GET',
        headers: getHeaders()
    });
    if (!response.ok) throw await buildError(response);
    return response.json();
}

export async function parseQuery(clientId, text) {
    const response = await fetch(`${BASE_URL}/parse`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({client_id: String(clientId), text})
    });
    if (!response.ok) throw await buildError(response);
    return response.json();
}

export async function getClientFields(clientId) {
    const response = await fetch(`${BASE_URL}/clients/${clientId}/fields`, {
        method: 'GET',
        headers: getHeaders()
    });
    if (!response.ok) throw await buildError(response);
    return response.json();
}

export async function queryData(clientId, params) {
    const response = await fetch(`${BASE_URL}/query`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
            client_id: String(clientId),
            data_source_type: params.data_source_type,
            date_range: params.date_range,
            fields: params.fields,
            filters: params.filters || []
        })
    });
    if (!response.ok) throw await buildError(response);
    return response.json();
}
